import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    "textTransform": 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    }
                },
                sizeLarge: {
                    height: 48
                },
                containedInherit: {
                    "color": theme.palette.grey[800],
                    "boxShadow": theme.customShadows.z8,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[400]
                    }
                },
                containedPrimary: {
                    "boxShadow": theme.customShadows.primary,
                    "background": theme.palette.themeGradient.primary,
                    "color": theme.palette.primary.contrastText,
                    '&:hover': {
                        background: theme.palette.themeGradient.primary
                    }
                },
                containedSecondary: {
                    boxShadow: theme.customShadows.secondary
                },
                outlinedInherit: {
                    "border": `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                },
                textInherit: {
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                },
                outlinedPrimary: {
                    "border": `1px solid ${theme.palette.grey[300]}`,
                    "color": theme.palette.grey[700],
                    "background": theme.palette.background.default,
                    '&:hover': {
                        backgroundColor: theme.palette.background.default,
                        border: `1px solid ${theme.palette.grey[300]}`,
                        color: theme.palette.primary.main
                    }
                },
                outlinedSecondary: {
                    "border": `1px solid ${theme.palette.secondary.light}`,
                    "color": theme.palette.secondary.main,
                    "background": theme.palette.background.default,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.lighter,
                        border: `1px solid ${theme.palette.secondary.light}`
                    }
                },
                outlinedInfo: {
                    "backgroundColor": theme.palette.background.default,
                    "border": `1px solid ${theme.palette.grey[300]}`,
                    "color": theme.palette.primary.main,
                    '&:hover': {
                        backgroundColor: theme.palette.background.default,
                        border: `1px solid ${theme.palette.grey[300]}`,
                        color: theme.palette.primary.main
                    }
                }
            }
        }
    };
}
